module.exports = __webpack_public_path__ + "img/sx.afa93cee.svg";